<div class="min-h-screen flex items-center justify-center bg-gray-50 p-4">
  <mat-card class="w-full max-w-sm p-6">
    <h2 class="text-2xl font-bold text-center mb-2">Forgot Password</h2>
    <p class="text-gray-500 text-center mb-6">Enter your email to receive a reset link</p>

    <div *ngIf="sent" class="text-center py-4">
      <mat-icon class="text-green-500" style="font-size:48px">check_circle</mat-icon>
      <p class="mt-2 text-gray-600">Check your email for reset instructions.</p>
      <a mat-button routerLink="/login" class="mt-4">Back to Login</a>
    </div>

    <form *ngIf="!sent" [formGroup]="form" (ngSubmit)="submit()">
      <mat-form-field class="w-full mb-4">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" autocomplete="email">
        <mat-error *ngIf="form.get('email')?.hasError('email')">Invalid email</mat-error>
      </mat-form-field>

      <button mat-raised-button color="primary" class="w-full" type="submit" [disabled]="loading || form.invalid">
        <mat-spinner *ngIf="loading" diameter="20" class="inline-block mr-2"></mat-spinner>
        Send Reset Link
      </button>

      <div class="text-center mt-4">
        <a mat-button routerLink="/login">Back to Login</a>
      </div>
    </form>
  </mat-card>
</div>
